import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  PolicyReviewAtRenewalPostRequestParams,
  PolicyReviewAtRenewalPostRequestBody,
  PolicyReviewAtRenewalPostResponse,
} from '@lio/api-types';
import { useClient } from '@utils/api-client';
import { reviewAtRenewalQueryKeys } from './keys';

export const useCreateReviewAtRenewal = () => {
  const client = useClient();
  const queryClient = useQueryClient();

  const result = useMutation<
    PolicyReviewAtRenewalPostResponse,
    Error,
    PolicyReviewAtRenewalPostRequestParams & { body: PolicyReviewAtRenewalPostRequestBody }
  >({
    mutationFn: ({
      policyId,
      body,
    }: PolicyReviewAtRenewalPostRequestParams & { body: PolicyReviewAtRenewalPostRequestBody }) =>
      client
        .post(`policy/${policyId}/review-at-renewal`, {
          json: body,
        })
        .json<PolicyReviewAtRenewalPostResponse>(),
    onSuccess: (_, { policyId }) => {
      queryClient.invalidateQueries({
        queryKey: reviewAtRenewalQueryKeys.get(policyId),
      });
      queryClient.invalidateQueries({
        queryKey: ['policy', { policyId }],
      });
    },
  });

  return { ...result, createReviewAtRenewal: result.mutateAsync };
};
